export const oneplus = {
  name: "oneplus" as const,
  svg: `<svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M9.06557 17.6721V15.9344H10.8033V10.7213H9.06557V8.95082H12.541V15.9016H14.3115V17.6393H9.06557V17.6721ZM20.377 22V10.6885H18.6393V20.2623H4.7377V6.36066H14.3115V4.62295H3V22H20.377ZM20.377 8.95082V6.32787H23V4.62295H20.377V2H18.6393V4.62295H16.0164V6.36066H18.6393V8.98361H20.377V8.95082Z"/></svg>`,
  keywords: ["oneplus"],
  category: "social" as const,
};
